export default class Storage {
    static get(key, defaultValue) {
        if (!key || !window.sessionStorage) {
            return defaultValue;
        }

        try {
            const rawItems = sessionStorage.getItem(key);

            return JSON.parse(rawItems) || defaultValue;
        } catch (ex) {
            return defaultValue;
        }
    }

    static set(key, payload) {
        if (!key || !window.sessionStorage) {
            return false;
        }

        try {
            const rawItems = JSON.stringify(payload);

            sessionStorage.setItem(key, rawItems);

            return true;
        } catch (ex) {
            return false;
        }
    }
}
